/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { SubscriptionRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { SubscriptionResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update a subscription for a customer
         * @summary Update a subscription
         * @param {string} storeId The store identifier.
         * @param {SubscriptionRequest} subscriptionRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscription: async (storeId: string, subscriptionRequest: SubscriptionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('subscription', 'storeId', storeId)
            // verify required parameter 'subscriptionRequest' is not null or undefined
            assertParamExists('subscription', 'subscriptionRequest', subscriptionRequest)
            const localVarPath = `/store/{storeId}/resources/subscription`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * Update a subscription for a customer
         * @summary Update a subscription
         * @param {string} storeId The store identifier.
         * @param {SubscriptionRequest} subscriptionRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscription(storeId: string, subscriptionRequest: SubscriptionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscription(storeId, subscriptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * Update a subscription for a customer
         * @summary Update a subscription
         * @param {string} storeId The store identifier.
         * @param {SubscriptionRequest} subscriptionRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscription(storeId: string, subscriptionRequest: SubscriptionRequest, options?: any): AxiosPromise<SubscriptionResponse> {
            return localVarFp.subscription(storeId, subscriptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * Update a subscription for a customer
     * @summary Update a subscription
     * @param {string} storeId The store identifier.
     * @param {SubscriptionRequest} subscriptionRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public subscription(storeId: string, subscriptionRequest: SubscriptionRequest, options?: any) {
        return SubscriptionApiFp(this.configuration).subscription(storeId, subscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
